export function getCitySlug(city) {
  return String(city || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function getMatchingCityProduct(products, citySlug) {
  const normalizedSlug = getCitySlug(citySlug);
  if (!normalizedSlug) {
    return null;
  }

  return products.find((product) => getCitySlug(product.city) === normalizedSlug) || null;
}

export function getTopAlignedScrollY({ elementTop, currentScrollY, topOffset = 16 }) {
  return Math.max(0, Math.round(currentScrollY + elementTop - topOffset));
}
